import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { Links } from './Links';

const { arrayOf, shape, string } = proptypes;

export const LinkSets = ({ sets = [] }) => {
  return (
    <div className="sui-grid sui-grid-cols-1 sui-gap-4 lg:sui-grid-cols-3 lg:sui-gap-6">
      {sets.map((set, i) => {
        return (
          <div className="sui-grow" key={`set_${set.category}_${i}`}>
            <Typography variant="h6">{set.category}</Typography>
            <Links links={set.links || []} />
          </div>
        );
      })}
    </div>
  );
};

LinkSets.propTypes = {
  sets: arrayOf(shape({
    category: string,
    links: arrayOf(shape({
      url: string,
      keyword: string
    })),
  })).isRequired
};
